import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faDownload, faCloudUploadAlt, faQuestionCircle, faCog, faCloud, faRoad, faUser, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { NavLink, useHistory } from 'react-router-dom';
import { ClickAwayListener } from '@material-ui/core';

const drawerWidth = 240;

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex', 
    width: '100%'
   
  },
  toolbar: {
    paddingRight: 24,    
    backgroundColor: '#D7D7D7',
    '@media only screen and (max-width: 3500px)': {
      height: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '60px',
    }, 
  },
  title: {
    flexGrow: 1,
    color: '#333333',    
    fontFamily: 'Avenir_Black',
    marginLeft: '30px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '24pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '32pt',
    }, 
  },
  signIn: {
    flexGrow: 1,
    color: '#24618E',    
    marginLeft: '10px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    }, 
  },
  paper: {
    margin: theme.spacing(1),
    paddingBottom: '3px',
  },
  dropMenu: {
    position: 'absolute',    
    zIndex: '999',
    minWidth:'200px',
    '@media only screen and (max-width: 3500px)': {
      width: '125px',
      top: '37px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '150px',
      top: '60px',
    },     
    '& li': {      
      padding: '5px 0px',
      color: 'rgba(36, 97, 142, 1)',
      listStyle: 'none',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt',
      }, 
    },      
    padding: '0%',
    '& .MuiPaper-root': {
      border: '1px solid #24618E',
    }
  },
  droplog: {
    top: '55px',
    zIndex: '999',
    position: 'absolute',
    right: '10%',
    width: '150px',
  },
  dropMenuUl: {
    paddingLeft: '10px',
    paddingTop: '5px',
  },
  dropAdminTools: {
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '5px',
    borderRadius: '5px',
    '& h5': {
      margin: '5px 5px 0',
      fontSize: '16px',
      fontWeight: 'normal',
    },
    '& ul': {
      margin: '2px 5px 0',
      paddingRight: '15px',
      paddingLeft: '25px',
    }
  },
  menuIuseEffectcon: {
    fontSize: '18px',
    marginRight: '10px',
  },
  toolbarIcon: {
    cursor: 'pointer',
    color: '#333',
    '@media only screen and (max-width: 3500px)': {
      height: '50px', width: '50px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '70px', width: '70px',
    },  
  },
  adminMenu: {
    padding: '10px',
  },
  header: {
    position: 'absolute',
    top: '0',
    width: '100%',
    zIndex:2,
    '& .MuiAppBar-colorPrimary': {
      backgroundColor: '#D7D7D7',
      borderBottom: '1px solid #24618E',
      padding: '5px 0',
    },
    '& .MuiToolbar-regular': {     
      '@media only screen and (max-width: 3500px)': {
        minHeight: '40px',
      },
      '@media only screen and (min-width: 3501px)': {
        minHeight: '60px',
      }, 
    },
    '& .MuiAppBar-root': {
      boxShadow: 'none',
    }
  },
  userIcon: {
    color: '#24618E',    
    marginTop: '2px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '25px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '40px',
    }, 
  },
  headerIcon:{
    '@media only screen and (max-width: 3500px)': {
      height: '38px',width: '164px',marginLeft: '25px',marginBottom:'-10px'
    },
    '@media only screen and (min-width: 3501px)': {
      height: '55px',width: '235px',marginLeft: '25px',marginBottom:'-15px'
    }, 
  },
}));
//End Css Code ...


//Start Header component code ....
export default function Header(props) {  
  let history = useHistory();
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  const [checkedlog, setCheckedLog] = React.useState(false);

  let email = sessionStorage.getItem('email');
  let token = sessionStorage.getItem('jwtToken')
  const handleMenu = () => {

    setChecked((prev) => !prev);
  };

  const handleClickAway = () => {
    setChecked(false);
  };


  const handleLogout = () => {
    setCheckedLog((prev) => !prev);
  };

  const signOut = () => {
    sessionStorage.removeItem('jwtToken')
    sessionStorage.removeItem('email')    
    history.push("/");
  }

  return (
    <React.Fragment>
      <div className={classes.header}>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar position="relative">
            <Toolbar className={classes.toolbar}>
              <ClickAwayListener onClickAway={() => handleClickAway()}>
                <MenuIcon onClick={handleMenu} className={classes.toolbarIcon} />
              </ClickAwayListener>
              <NavLink to={{ pathname: '/', state: { clicked: true } }} style={{ textDecoration: 'none' }}><img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.headerIcon}/></NavLink>
              {sessionStorage.getItem('displayName') ?
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                  {sessionStorage.getItem('displayName')}
                </Typography> : <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>

                </Typography>
              }

              <NavLink to="/sign_in" style={{ textDecoration: 'none' }}><div style={{
                display: 'inline-flex', padding: '70px', paddingBottom: '10px',
                marginTop: '-60px'
              }}>
                <FontAwesomeIcon icon={faUserCircle} className={classes.userIcon} />
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.signIn}>
                  <span>Sign In</span>
                </Typography>
              </div>
              </NavLink>
            </Toolbar>
          </AppBar>
        </div>
        {checked ?
          <div className={classes.dropMenu}>
            <Collapse in={checked}>
              <Paper elevation={4} className={classes.paper}>
                <ul className={classes.dropMenuUl}>
                  <li><NavLink to={{ pathname: '/', state: { clicked: true } }} style={{ textDecoration: 'none', color: '#24618E' }} title="Home"><FontAwesomeIcon icon={faHome} className={classes.menuIcon} /> Home</NavLink></li>
                  <li title="Help"><NavLink to="/help" style={{ textDecoration: 'none', color: '#24618E' }} title="Help"><FontAwesomeIcon icon={faQuestionCircle} className={classes.menuIcon} /> Help</NavLink></li>
                </ul>

              </Paper>
            </Collapse>

          </div> : null}

        <div className={classes.droplog}>
          <Collapse in={checkedlog}>
            <Paper elevation={4} className={classes.paper}>
              <div className={classes.adminMenu}><NavLink to="#" onClick={() => { signOut() }}>Sign Out</NavLink></div>
            </Paper>
          </Collapse>
        </div>
      </div>
    </React.Fragment>
  );
}
//End Header component code ....